document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  // Dawn's real Add to cart button is a submit button named "add"
  var trigger = document.querySelector('button[name="add"]');
  if (!trigger) return;

  function toggleBar() {
    var rect = trigger.getBoundingClientRect();
    if (rect.bottom < 0) {
      bar.classList.add('sticky-atc-bar--visible');
    } else {
      bar.classList.remove('sticky-atc-bar--visible');
    }
  }

  window.addEventListener('scroll', toggleBar, { passive: true });
  toggleBar();

  var stickyButton = document.getElementById('sticky-atc-button');
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      trigger.click();
    });
  }
});